import React from 'react';

export default class Panel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: this.props.active,
      open: this.props.open || true
    };
  }

  componentWillReceiveProps = nextProps => {
    if (this.state.active !== nextProps.active) {
      this.setState({ active: nextProps.active });
    }
  };

  render = () => {
    const isActive = this.state.active;
    const isOpen = this.state.open;

    return (
      <section
        className={`${this.props.className} panel ${
          isActive ? '' : 'inactive'
        } ${isOpen ? 'open' : 'closed'}`}
      >
        <h5 className="header">
          {this.props.title}
          <i
            className={
              'panel-arrow fa ' + (isOpen ? 'fa-chevron-up' : 'fa-chevron-down')
            }
            onClick={this.handlePanelToggle}
          />
        </h5>
        <article className="content">{this.props.children}</article>
      </section>
    );
  };

  handlePanelToggle = () => this.setState({ open: !this.state.open });
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/panel.js